const academyReworkings = {
	main: 'Відпрацювання',
	welcome: 'Вітаємо, {{name}}!',
	startDescription: 'Оберіть локацію, групу та програму, щоб записатися на відпрацювання.',
	studentRequired: 'Запис на відпрацювання доступний для обраного студента.',
	location: 'Локація',
	group: 'Група',
	program: 'Програма',
	selectLocation: 'Спочатку оберіть локацію.',
	selectGroup: 'Спочатку оберіть групу.',
	selectProgram: 'Спочатку оберіть програму для відпрацювання.',
	noOptions: 'Немає доступних варіантів',
	retry: 'Спробувати ще',
	book: 'Записатися на відпрацювання',
	bookDescription: 'Оберіть до трьох уроків, а потім час і тьютора.',
	myBookings: 'Мої записи',
	myBookingsDescription: 'Ваші записи на відпрацювання.',
	viewBooking: 'Деталі',
	bookingDetails: 'Деталі запису',
	bookingDate: 'Дата',
	lesson: 'Урок',
	zoomId: 'Zoom ID',
	zoomAccessCode: 'Код доступу Zoom',
	zoomLink: 'Посилання Zoom',
	miroLink: 'Посилання Miro',
	teacherComment: 'Коментар викладача',
	studentComment: 'Ваш коментар',
	closeDetails: 'Закрити',
	noBookings: 'У вас поки немає запланованих відпрацювань.',
	cancellationHint: 'Скасувати запис можна не пізніше ніж за {{minutes}} хвилин до початку.',
	cancelBooking: 'Скасувати',
	cancelTitle: 'Скасувати запис?',
	cancelDescription:
		'{{lesson}} · {{date}}. Після скасування урок знову буде доступний для запису.',
	cancellationUnavailable: 'Скасування недоступне',
	cancellationBlocked:
		'До початку залишилося менше {{minutes}} хвилин. За потреби зверніться до адміністратора вашої локації.',
	keepBooking: 'Залишити запис',
	confirmCancel: 'Так, скасувати',
	understood: 'Зрозуміло',
	online: 'Онлайн',
	offline: 'Офлайн',
	chooseLessons: 'Які уроки відпрацьовуємо?',
	lessonsHint: 'Оберіть до 3 пропущених уроків. Кожне відпрацювання триває 20 хвилин.',
	noLessons: 'Для цієї програми немає уроків, доступних для відпрацювання.',
	missedOn: 'Пропущено {{date}}',
	selectedLessons: 'Обрано {{count}} з 3',
	nextDays: 'Далі: дні',
	nextTime: 'Далі: час',
	chooseDays: 'Оберіть зручні дні',
	daysHint: 'Можна обрати кілька днів. Кількість доступного часу видно до переходу далі.',
	selectDay: 'Обрати день {{date}}',
	selectedDays: 'Обрано днів: {{count}}',
	availableTimes: 'Доступний час: {{count}}',
	noTimes: 'Немає вільного часу',
	dayNoSlots: 'На цей день уже немає вільного часу. Поверніться, щоб обрати інший день.',
	selected: 'Обрано',
	days: 'Дні',
	time: 'Час',
	chooseTimes: 'Оберіть зручний час',
	timesHint: 'Оберіть {{count}} слотів по 20 хвилин у вибрані дні.',
	previousWeek: 'Попередній тиждень',
	nextWeek: 'Наступний тиждень',
	currentWeek: 'Поточний тиждень',
	timeZone: 'Розклад відображено за київським часом.',
	bookingDeadline: 'Записатися можна більше ніж за {{hours}} годин до початку заняття.',
	tutorsAvailable: 'Доступних тьюторів: {{count}}',
	selectTime: 'Обрати {{date}}, {{time}}',
	noSlots: 'Цього тижня немає доступних 20-хвилинних слотів. Спробуйте інший тиждень.',
	selectedTimes: 'Обрано часу: {{count}} з {{total}}',
	nextTutor: 'Далі: тьютори',
	chooseTutors: 'Ваші тьютори',
	tutorsHint: 'Спочатку обрано тьютора з найменшим навантаженням. За потреби можна обрати іншого.',
	tutor: 'Тьютор',
	selectTutor: 'Оберіть тьютора.',
	nextConfirm: 'Далі: підтвердження',
	confirmTitle: 'Підтвердіть запис',
	partiallyBooked: 'Уже заброньовано: {{count}}. Повторна спроба забронює лише решту уроків.',
	booked: 'Заброньовано',
	phone: 'Номер телефону',
	contactHint: 'Цей номер телефону та коментар буде додано до кожного обраного запису.',
	stepProgress: 'Крок {{current}} з {{total}}',
	comment: 'Коментар (необов’язково)',
	confirmBooking: 'Підтвердити запис',
	requestFailed: 'Не вдалося завантажити або зберегти запис. Спробуйте ще раз.',
	slotsChanged: 'Деякий час уже зайнятий або термін запису минув. Оберіть інший час.',
	lessons: 'Уроки',
	dateTime: 'Дата і час',
	confirmation: 'Підтвердження',
	back: 'Назад',
};

export default academyReworkings;
